<template>
    <!-- Fixed layout with set column widths, so every appendix's table lines up the same -->
    <table class="w-full table-fixed text-left text-sm">
        <colgroup>
            <col v-if="showDiff" class="w-8">
            <col class="w-20">
            <col>
            <col v-for="column in columns" :key="column.label" :class="column.width">
        </colgroup>
        <thead class="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
            <tr>
                <th v-if="showDiff" class="py-2"><span class="sr-only">Change</span></th>
                <th class="px-4 py-2 font-medium">ID</th>
                <th class="px-4 py-2 font-medium">Company Name</th>
                <th v-for="column in columns" :key="column.label" class="px-4 py-2 font-medium">{{ column.label }}</th>
            </tr>
        </thead>
        <tbody v-for="group in groups" :key="group.label ?? 'all'" class="divide-y divide-gray-100">
            <tr v-if="group.label" class="bg-gray-100">
                <td :colspan="columns.length + (showDiff ? 3 : 2)" class="px-4 py-1.5 text-xs font-semibold text-dark-primary">
                    {{ group.label }}
                    <span class="ml-1 font-normal text-gray-500">({{ group.companies.length }})</span>
                </td>
            </tr>
            <tr
                v-for="company in group.companies"
                :key="`${company.id}${company.diff ?? ''}`"
                :class="DIFF_ROW_CLASSES[company.diff] ?? 'hover:bg-gray-50'"
            >
                <td v-if="showDiff" class="py-2 text-center font-mono font-semibold">{{ company.diff === '-' ? '−' : company.diff }}</td>
                <td class="px-4 py-2 text-gray-500 tabular-nums">{{ company.id }}</td>
                <td class="px-4 py-2 font-medium break-words">
                    {{ company.company_name }}
                    <span v-if="company.diffNote" class="ml-1 text-xs font-normal opacity-75">({{ company.diffNote }})</span>
                </td>
                <td v-for="column in columns" :key="column.label" :class="['px-4 py-2 break-words', { 'text-gray-700': !company.diff }]">{{ column.value(company) }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { CLIENT_APPENDIX_COLUMNS } from '@/utils/clientAppendix';

// groups: [{ label, companies }]; a group with no label is shown without a heading row.
// showDiff adds a gutter for rows marked diff '+' (added) or '-' (removed), from exhibitDiffRows().
const props = defineProps({
    columnLabels: Array,
    groups: Array,
    showDiff: Boolean
})

const DIFF_ROW_CLASSES = {
    '+': 'bg-green-50 text-green-900',
    '-': 'bg-red-50 text-red-900',
}

const columns = computed(() => CLIENT_APPENDIX_COLUMNS.filter((column) => props.columnLabels.includes(column.label)))
</script>
